<!-- Bob Assisted Hours Widget -->
<div
    class="rounded-[20px] bg-white p-4 h-full flex flex-col gap-3 min-w-0 shadow-[0_-6px_16px_-4px_rgba(0,0,0,0.1),0_6px_16px_-4px_rgba(0,0,0,0.1)]">
    <!-- Header -->
    <div class="flex items-center gap-2 text-gray-900">
        <span class="widget-title">Bob assisted hours</span>
        <app-icon type="info" source="lucide" size="sm" class="text-gray-400"
            pTooltip="Displays the total duration of assistance provided by Bob across all your sessions"
            tooltipPosition="top"></app-icon>
    </div>

    <!-- Two-column body: per-surface bars (left) + donut + total (right) -->
    <div class="grid grid-cols-1 sm:grid-cols-3 gap-2 flex-1 min-w-0 items-center">
        @if (loading()) {
        <!-- Skeleton: per-surface bar list -->
        <div class="sm:col-span-2 flex flex-col pr-2 gap-4 min-w-0">
            <div *ngFor="let i of [0, 1, 2, 3, 4]" class="min-w-0 flex flex-col gap-1.5">
                <div class="flex items-center justify-between gap-3">
                    <p-skeleton width="55%" height="0.625rem"></p-skeleton>
                    <p-skeleton width="1.5rem" height="0.625rem"></p-skeleton>
                </div>
                <p-skeleton width="100%" height="0.625rem" borderRadius="0.375rem"></p-skeleton>
            </div>
        </div>

        <!-- Skeleton: chart + total -->
        <div class="flex flex-col items-center justify-center min-w-0 gap-3">
            <p-skeleton width="4.375rem" height="1.75rem"></p-skeleton>
            <p-skeleton shape="circle" width="10rem" height="10rem"></p-skeleton>
        </div>
        } @else {
        <!-- Per-surface bar list (spans 2 of 3 cols on >= sm) -->
        <div class="sm:col-span-2 flex flex-col pr-2 gap-4 min-w-0 scrollbar-thin overflow-y-auto max-h-[290px]">
            <div *ngFor="let surface of data()?.surfaces; let i = index" class="min-w-0 flex flex-col gap-1">
                <!-- Row 1: dot, name, percent -->
                <div class="flex items-center justify-between text-xs text-gray-600 min-w-0 gap-3">
                    <div class="flex items-center gap-1.5 min-w-0">
                        <span class="inline-block w-2 h-2 rounded-full flex-shrink-0"
                            [style.background-color]="colors[i % colors.length]"></span>
                        <span class="truncate">{{ surface.name }}</span>
                    </div>
                    <span class="text-gray-500 flex-shrink-0">{{ surface.percent }}%</span>
                </div>
                <!-- Row 2: hours (start) · bar -->
                <div class="flex items-center gap-2 min-w-0">
                    <span class="text-sm font-semibold text-gray-900 whitespace-nowrap flex-shrink-0"
                        [title]="surface.hours + ' hrs'">
                        {{ formatHours(surface.hours) }} hrs
                    </span>
                    <div class="flex-1 min-w-0 h-1.5 bg-gray-100 rounded-full overflow-hidden">
                        <div class="h-full rounded-full" [style.width.%]="surface.percent"
                            [style.background-color]="colors[i % colors.length]"></div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Chart + total (right column) -->
        <div class="flex flex-col items-center justify-center min-w-0 gap-2">
            <div class="flex items-baseline gap-1 min-w-0 max-w-full">
                <span class="text-3xl font-bold text-gray-900 truncate min-w-0"
                    [title]="(data()?.totalHours ?? 0) + ' hrs'">
                    {{ formatHours(data()?.totalHours ?? 0) }}
                </span>
                <span class="text-xs text-gray-500 flex-shrink-0">hrs</span>
            </div>
            <div echarts [options]="chartOptions()" class="w-full h-48"></div>
        </div>
        }
    </div>
</div>